<template>
  <el-card>
    <el-form ref="searchInfo" class="global-form" :inline="true">
      <el-form-item prop="dateRange">
        <el-date-picker
          :clearable = "false"
          v-model="searchInfo.dateRange"
          type="daterange"
          range-separator="-"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="echarts" ref="echart"></div>
    <el-table class="global-table" v-loading="loading" :data="dataList">
      <el-table-column label="设备串号" show-overflow-tooltip prop="deviceNumber" min-width="130px"></el-table-column>
      <el-table-column label="工作状态" prop="ws" min-width="100px">
        <template v-slot="{ row }">
          {{row.ws === '0' ? '待机' : row.ws === '1' ? '工作' : '--'}}
        </template>
      </el-table-column>
      <el-table-column label="灯管状态" prop="lamp" min-width="100px">
        <template v-slot="{ row }">
          {{row.lamp === '0' ? '灭' : row.lamp === '1' ? '亮' : '--'}}
        </template>
      </el-table-column>
      <el-table-column label="加热仓温度(℃)" prop="hrt" min-width="110px">
        <template v-slot="{ row }">
          {{row.hrt || '--'}}
        </template>
      </el-table-column>
      <el-table-column label="环境湿度(%)" prop="ah" min-width="100px">
        <template v-slot="{ row }">
          {{row.ah || '--'}}
        </template>
      </el-table-column>
      <el-table-column label="光照强度(lx)" prop="lux" min-width="120px">
        <template v-slot="{ row }">
          {{row.lux || '--'}}
        </template>
      </el-table-column>
      <el-table-column label="环境温度(℃)" prop="at" min-width="120px">
        <template v-slot="{ row }">
          {{row.at || '--'}}
        </template>
      </el-table-column>
      <el-table-column label="雨控状态" prop="rps" min-width="100px">
        <template v-slot="{ row }">
          {{row.rps === '1' ? '雨控' : row.rps === '0' ? '正常' : '--'}}
        </template>
      </el-table-column>
      <el-table-column label="光控状态" prop="lps" min-width="100px">
        <template v-slot="{ row }">
          {{row.lps === '1' ? '光控' : row.lps === '0' ? '正常' : '--'}}
        </template>
      </el-table-column>
      <el-table-column label="温控状态" prop="tps" min-width="100px">
        <template v-slot="{ row }">
          {{row.tps === '1' ? '温控' : row.tps === '0' ? '正常' : '--'}}
        </template>
      </el-table-column>
      <el-table-column label="上报时间" prop="collectTime" min-width="140px">
        <template v-slot="{ row }">
          {{row.collectTime || '--'}}
        </template>
      </el-table-column>
    </el-table>
    <global-pagination
      @size-change="getData"
      @current-change="getData"
      :current-page.sync="page"
      :page-size.sync="size"
      :total="total">
    </global-pagination>
  </el-card>
</template>

<script>
// import * as echarts from 'echarts'
import { px2vw } from '@/utils/util'
export default {
  name: 'InsectHistory',
  data () {
    return {
      searchInfo: {
        dateRange: []
      },
      selectTime: 0,
      pickerOptions: {
        // 选中日期后会执行的回调
        onPick: (date) => {
          this.selectTime = date.minDate.getTime()
          if (date.maxDate) {
            this.selectTime = 0
          }
        },
        disabledDate: (time) => {
          if (this.selectTime !== 0) {
            const dayTime = 29 * 24 * 3600 * 1000
            const minTime = this.selectTime - dayTime
            const maxTime = this.selectTime + dayTime
            return (time.getTime() < minTime || time.getTime() > maxTime)
          }
        }
      },
      loading: false,
      dataList: [],
      page: 1,
      size: 10,
      total: 0,
      echart: null,
      echartSelect: '0',
      echartData: {
        ah: [],
        at: [],
        collectTime: []
      },
      typeList: []
    }
  },
  computed: {
    deviceNumber () {
      return this.$route.params.deviceNumber
    }
  },
  created () {
    this.initTime()
    this.getData()
  },
  mounted () {
    window.addEventListener('resize', this.resize)
  },
  destroyed () {
    window.removeEventListener('resize', this.resize)
  },
  methods: {
    initTime () {
      const val = this.$dayjs().format('YYYY-MM-DD')
      const vals = this.$dayjs().subtract(7, 'day').format('YYYY-MM-DD')
      this.searchInfo.dateRange = [vals, val]
    },
    getData () {
      if (this.searchInfo.dateRange && this.searchInfo.dateRange[0]) {
        this.loading = true
        this.$axios.get(this.$apis.iot.selectInsectDataByPage, {
          deviceNumber: this.deviceNumber,
          startTime: this.searchInfo.dateRange[0],
          endTime: this.searchInfo.dateRange[1],
          page: this.page,
          size: this.size
        }).then((res) => {
          this.total = res.total || 0
          this.dataList = res.list || []
          this.getEchartsData()
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$message.error('请选择查询日期范围')
      }
    },
    onSearch () {
      this.page = 1
      this.getData()
    },
    // 图表数据
    getEchartsData () {
      this.echartData = {
        at: [],
        ah: [],
        collectTime: []
      }
      if (this.dataList.length > 0) {
        this.dataList.forEach(item => {
          this.echartData.at.push(item.at)
          this.echartData.ah.push(item.ah)
          this.echartData.collectTime.push(item.collectTime)
        })
      }
      this.drawEchart(this.echartData.at, this.echartData.ah, this.echartData.collectTime)
    },
    drawEchart (at, ah, date) {
      this.echart = echarts.init(this.$refs.echart)
      const option = {
        title: {
          text: '温度湿度统计'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          type: 'plain',
          left: px2vw(25),
          top: px2vw(40),
          icon: 'rect',
          itemHeight: px2vw(2),
          itemWidth: px2vw(12),
          itemGap: px2vw(16),
          textStyle: {
            color: 'rgba(140, 140, 140, 1)'
          }
        },
        grid: {
          bottom: px2vw(30),
          top: px2vw(80),
          left: px2vw(55),
          right: px2vw(30)
        },
        color: ['#2C8EFFFF', '#FFC117FF'],
        xAxis: [
          {
            type: 'category',
            data: date,
            axisTick: {
              alignWithLabel: true
            },
            axisLine: {
              lineStyle: {
                color: '#00000073'
              }
            },
            axisLabel: {
              margin: px2vw(15)
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: '#00000026'
              }
            },
            axisLabel: {
              color: '#00000073'
            }
          }
        ],
        series: [
          {
            name: '温度',
            type: 'line',
            symbol: 'none',
            smooth: true,
            lineStyle: {
              width: px2vw(4),
              shadowBlur: 0,
              shadowColor: '#2C8EFF33',
              shadowOffsetY: px2vw(20)
            },
            data: at
          },
          {
            name: '湿度',
            type: 'line',
            symbol: 'none',
            smooth: true,
            lineStyle: {
              width: px2vw(4),
              shadowBlur: 0,
              shadowColor: '#FFC11733',
              shadowOffsetY: px2vw(20)
            },
            data: ah
          }
        ]
      }
      this.echart.setOption(option)
    },
    resize () {
      if (this.echart) {
        this.echart.resize()
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.echarts{
  width: 100%;
  height: 450px;
  margin-bottom: 30px;
}
</style>
